module.exports = __webpack_public_path__ + "static/media/GTWalsheimPro-Regular.550c7b05.ttf";